<template>
  <div style="background: #FAF9F5;">
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="schools-posts-area" >
        <div class="row">
          <div class="col-lg-3 schools-posts-area-lf" style="padding-right: 0;">
              <div class="schools-posts-area-lf-t" style="font-size: 24px; line-height: 28px">
                International activities</div>
              <ul class="schools-posts-area-lf-m">
                    <li v-for="item in blogList" @click="checkLi(item.id)" :class="[currentBlog.id===item.id?'active':'']">{{item.title}}</li>

              </ul>
            <img class="schools-posts-area-lf-b" src="http://en.sc.ruc.edu.cn/static/images/school/png10.png" />
          </div>
          <div class="col-lg-9 post-list blog-post-list">
            <div class="single-post">



                <h2 class="blog-detail-tit">
                  {{ currentBlog.title }}
                </h2>


              <div class="blog-detail-content content-wrap  wow slideInRight">
                <img class="blog-detail-content-img wow slideInLeft" :src="currentBlog.img" alt="" >
                <p v-html="currentBlog.content">
                </p>

              </div>



            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<script>
  export default {
    data () {
      return {
        currentBlog: {},
        blogList: [
          {
            id: '1',
            title: 'The China-Europe Civilization Forum',
            img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/detail/1.JPG',
            author: '中法学院',
            content: 'The China-Europe Civilization Forum is jointly hosted by the International Office of Renmin University of China (Hong Kong, Macao and Taiwan Affairs Office), Suzhou Campus, University of Sorbonne, Paul Valéry University and KEDGE Business School. It serves as a high-level platform for cultural communication and academic exchange between China and Europe. The forum focuses on academic hotspots and cutting-edge issues in humanities and social sciences. Top scholars from China and Europe produced a batch of high-level academic outcomes and leading achievements, which promotes high-quality international studies, and the communication of civilizations in China and in Europe. The Forum was first held in Paris on September 21, 2023.'
          }, {
            id: '2',
            title: 'China-France Higher Education Forum',
            img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/detail/2.jpg',
            author: '智慧治理学院',
            content: 'China-France Higher Education Forum is jointly held by Institute of French Language Studies of Renmin University of China and INSTITUT DE RECHERCHE INTERSITE ÉTUDES CULTURELLES (IRIEC) of Paul-Valéry Montpellier 3 University. Domestic and international scholars together had in-depth discussions on the cooperation mode, management framework, educational philosophy, teaching experience of higher education in China and France, in order to improve the theoretical framework of exchanges and cooperation on higher education between two countries.'
          }, {
            id: '3',
            title: 'International Academic Conference on Global Evolution of Population Aging from an Interdisciplinary Perspective',
            img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/detail/3.jpg',
            author: '丝路学院',
            content: 'China has the largest elderly population in the world, while France was the earliest country stepping into an aging society. International Academic Conference on Global Evolution of Population Aging from an Interdisciplinary Perspective was held at Suzhou Campus of RUC on September 24th and 25th, 2022. Experts and scholars from China and France had thorough discussions on the common issue: aging population from many perspectives, including politics, economy, society, culture, literature, etc.'
          }, {
            id: '4',
            title: 'Policy Forum in Asia',
            img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/detail/4.jpg',
            author: '国际学院',
            content: 'Policy Forum in Asia provides an important platform for bilateral academic exchanges between Renmin University of China and Hitotsubashi University, aiming at in-depth communication and cooperation in various disciplines. This forum effectively promotes cooperation in scientific research, students training, cultural exchange and other aspects between two universities, which is of great significance for further cooperation and exchanges among people and governments in both countries. The Tenth Policy Forum in Asia was held at Suzhou Campus of RUC on November 20, 2023.'
          }, {
            id: '5',
            title: 'World Conference on Sinology',
            img: 'http://en.sc.ruc.edu.cn/static/images/collaboration/detail/5.jpg',
            author: '国际学院',
            content: 'World Conference on Sinology, founded in 2007, jointly organized by the Center for Language Education and Cooperation of the Ministry of Education and Renmin University of China. Held every two years, it serves as a link between Chines academic research and overseas Sinology. This forum is also a high-level academic platform for promotion of "New Sinology" and "Great Sinology", interdisciplinary development of humanities, connection between sinologists, and cultivation of young talents. The Eighth World Conference on Sinology was held at Suzhou Campus from November 5th to 6th, 2023.'
          }
        ]
      }
    },
    created () {
      const id = this.$route.query.id
      this.currentBlog = this.getId(id)
      console.log(id, this.currentBlog)
    },
    methods: {
      getId (id) {
        return this.blogList.find(item => item.id === id)
      },
      checkLi (id) {
        this.currentBlog = this.getId(id)
      }
    }
  }
</script>

<style scoped lang="scss">
.blog-detail-tit:before{
  content: ' ';
  background-image: url(http://en.sc.ruc.edu.cn/static/images/titBg.png);

}

.blog-detail-content{
  width: 90%;
  margin: 40px auto 10px auto;
  display: flex;
  .blog-detail-content-img{
    width: 35%;
    margin: 10px 20px 5px 0px;
    flex-shrink: 0;
    height: fit-content;
  }
  p{
    flex: 1;
    font-weight: 400;
    font-size: 17px;
    line-height: 1.6;
    color: #666666;
  }
}


@media (max-width: 575.98px) {
  .blog-detail-content {
    display: block !important;
    width: 90%;
    margin: 10px auto 10px auto;

    .blog-detail-content-img {
      width: 100%;
      margin: 8px 10px 0px 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// collaborationDetails.vue?0301991c